import React, { useEffect, useId, useState, useRef } from "react";
import Layout, { PixelStyle } from "../../components/layout";
import { database } from "../../config/config";
import { get, push, ref, set } from "firebase/database";
import { IoIosAdd } from "react-icons/io";
import { MdOutlineAdd } from "react-icons/md";
import { document as documentIcon, tabularTableIcon } from "../../assets";
import { RiDeleteBin6Line } from "react-icons/ri";
import { v4 as uuidv4 } from "uuid";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { HeaderContainer } from "./viewreport";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { SearchableDropdown } from "../../components/reportComponents";
import {
  TableComponent,
  TabularTableComponent,
  TabularTablePreview,
} from "./tableComponents";
import { useAppContext } from "../../context/appContext";
import axios from "axios";
import { CREATE_TEMPLATE_MUTATION } from "../../apis/templates/report/mutation";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_URL } from "../../apis/apiurl";
import { fetchAllCompanyList } from "../../apis/company/companyList";
import PopupModel from "../../components/model/popupModel";
import { Cross, Loader2 } from "lucide-react";
import { GetAllTourAPI, GetTourByIdAPI } from "../../apis/tour";
import { IoClose } from "react-icons/io5";
import Modal from "../../components/Modal";
import EmailSection from "../../components/EmailInput";
import ExportConfig from "../../components/ExportConfig";
import * as XLSX from "xlsx";
import { uploadExcelDataAPI, getExcelDataByReportAPI } from "../../apis/excelData";

const CreateReport = () => {
  const { setPopupMessage } = useAppContext();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [chooseTable, setChooseTable] = useState(false);
  const [selectedDataType, setSelectedDataType] = useState("Table"); // Default to Table as shown in image
  const [docTableName, setDocTableName] = useState(`table 1`);
  const [TabuTableName, setTabuTableName] = useState(`table 1`);
  const [documentTableData, setDocumentTableData] = useState([]);
  const [TabularTableData, setTabularTableData] = useState([]);
  const [documentTable, setDocumentTable] = useState("");
  const [tabularTable, setTabularTable] = useState("");
  const [openDocument, setOpenDocument] = useState(false);
  const [openTabular, setOpenTabular] = useState(false);

  // const { reportTempId } = useParams();
  const [reportTempId, setReportTempId] = useState(null);
  const navigate = useNavigate();
  const [reportName, setReportName] = useState("");
  const [tables, setTables] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  // const [successMessage, setSuccessMessage] = useState('');
  // const [errorMessage, setErrorMessage] = useState('');
  const [showAddTableModal, setShowAddTableModal] = useState(false);
  const [showModal, setShowModal] = useState(false); // Initially hidden
  const [tableIndex, setTableIndex] = useState("");
  const [columnIndex, setColumnIndex] = useState("");
  // const [allTables, setAllTables] = useState([]);
  const [reportTemplates, setReportTemplates] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companyLocationId, setCompanyLocationId] = useState("");
  // const [previewTableIds, setPreviewTableIds] = useState([]);
  const [addfixedValues, setAddfixedValues] = useState(false);
  const [companyList, setCompanyList] = useState("");
  const [email, setEmail] = useState({
    to: [],
    cc: [],
    bcc: [],
  });
  const [exportConfig, setExportConfig] = useState({
    generateType: "",
    blackAndWhite: false,
    orientation: "portrait",
  });

  // const [popupMessage, setPopupMessage] = useState("");
  // const [ShowPopUp, setShowPopUP] = useState(false);

  const { isChangesInCreateReport, setIsChangesInCreateReport } =
    useAppContext();
  useEffect(() => {
    fetchAllCompanyList().then((data) => setCompanyList(data));
  }, []);

  // Helper function to manage sequences when ref is set
  const manageSequencesForRef = (columns, refColumnIndex) => {
    const updatedColumns = [...columns];
    
    // Set the new ref column to sequence 1 (this is the primary ref)
    updatedColumns[refColumnIndex].sequence = "1";
    
    // Get all other columns (excluding the one being set to ref)
    const otherColumns = updatedColumns
      .map((col, idx) => ({ col, idx }))
      .filter(({ idx }) => idx !== refColumnIndex);
    
    // Sort other columns by current sequence to maintain order
    otherColumns.sort((a, b) => {
      const aSeq = Number(a.col.sequence) || 0;
      const bSeq = Number(b.col.sequence) || 0;
      return aSeq - bSeq;
    });
    
    // Reassign all other columns starting from sequence 2
    otherColumns.forEach(({ idx }, index) => {
      updatedColumns[idx].sequence = String(index + 2);
    });
    
    return updatedColumns;
  };

  // Helper function to sort columns: Ref columns first, then others by sequence
  const sortColumns = (columns) => {
    return [...columns].sort((a, b) => {
      const aSequence = Number(a?.sequence) || 0;
      const bSequence = Number(b?.sequence) || 0;
      const aIsRef = a?.format === "ref";
      const bIsRef = b?.format === "ref";
      
      // If one is Ref and the other isn't, Ref comes first
      if (aIsRef && !bIsRef) return -1;
      if (!aIsRef && bIsRef) return 1;
      
      // If both are Ref or both are not Ref, sort by sequence
      return aSequence - bSequence;
    });
  };

  // Helper function to arrange all columns strictly by sequence before API call
  const arrangeColumnsBySequence = (tables) => {
    return tables.map((table) => {
      const columns = [...(table.columns || [])];
      
      // Sort all columns strictly by sequence number (ascending)
      // Ref columns with sequence 1 come first, then all others by sequence
      const sortedColumns = columns.sort((a, b) => {
        const aSequence = Number(a?.sequence) || 999999; // Put items without sequence at the end
        const bSequence = Number(b?.sequence) || 999999;
        const aIsRef = a?.format === "ref";
        const bIsRef = b?.format === "ref";
        
        // Primary sort: by sequence number
        if (aSequence !== bSequence) {
          return aSequence - bSequence;
        }
        
        // If sequences are equal, ref comes first
        if (aIsRef && !bIsRef) return -1;
        if (!aIsRef && bIsRef) return 1;
        
        return 0;
      });
      
      return {
        ...table,
        columns: sortedColumns,
      };
    });
  };

  // Helper function to ensure ref columns have sequence 1 before saving
  const normalizeSequencesForRef = (tables) => {
    return tables.map((table) => {
      const columns = [...(table.columns || [])];
      const refColumns = columns.filter((col) => col.format === "ref");
      const nonRefColumns = columns.filter((col) => col.format !== "ref");
      
      // Sort ref columns by current sequence, then assign sequences starting from 1
      refColumns.sort((a, b) => {
        const aSeq = Number(a.sequence) || 0;
        const bSeq = Number(b.sequence) || 0;
        return aSeq - bSeq;
      });
      
      // Ensure first ref column always has sequence 1, others get 2, 3, etc.
      refColumns.forEach((col, index) => {
        col.sequence = String(index + 1);
      });
      
      // Sort non-ref columns by current sequence and reassign starting after ref columns
      nonRefColumns.sort((a, b) => {
        const aSeq = Number(a.sequence) || 0;
        const bSeq = Number(b.sequence) || 0;
        return aSeq - bSeq;
      });
      
      // Non-ref columns start from sequence (number of refs + 1)
      const startSequence = refColumns.length > 0 ? refColumns.length + 1 : 1;
      nonRefColumns.forEach((col, index) => {
        col.sequence = String(startSequence + index);
      });
      
      // Combine: ref columns first, then non-ref columns
      return {
        ...table,
        columns: [...refColumns, ...nonRefColumns],
      };
    });
  };

  const useCreateTemplate = () => {
    const mutation = useMutation({
      mutationFn: async ({ reportName, companyId, tables }) => {
        // Step 1: Normalize sequences: ensure ref columns have sequence 1
        const normalizedTables = normalizeSequencesForRef(tables);
        
        // Step 2: Sort columns in each table: Ref first, then by sequence
        const sortedTables = normalizedTables.map((table) => ({
          ...table,
          columns: sortColumns(table.columns || []),
        }));
        
        // Step 3: Final arrangement - ensure all columns are strictly ordered by sequence before API call
        const arrangedTables = arrangeColumnsBySequence(sortedTables);
        
        const variables = {
          reportName,
          companyId,
          tables: arrangedTables,
          email: email,
          exportConfig: exportConfig,
        };
        // console.log("tablestables", sortedTables);
        try {
          const response = await axios.post(
            `${API_URL}/graphql`,
            {
              query: CREATE_TEMPLATE_MUTATION,
              variables,
            },
            {
              headers: { "Content-Type": "application/json" },
            }
          );
          return response.data; // Return the data from the response
        } catch (error) {
          console.error("Error:", error);
          throw error; // Re-throw the error to be handled by TanStack Query
        }
      },
      onSuccess: (data) => {
        if (data?.data?.createTemplate.success) {
          //  toast("Template is created");
          setPopupMessage("Template is created");
          // setShowPopUP(true);
        } else if (data?.data?.createTemplate.success === false) {
          //  toast(data?.data?.createTemplate.message);
          setPopupMessage(data?.data?.createTemplate.message);
          // setShowPopUP(true);
        } else toast("Something went wrong");
        // console.log(
        //   "Template created successfully:",
        //   data?.data?.createTemplate
        // );
        // Handle success, e.g., show a success message, update UI
      },
      onError: (error) => {
        console.error("Error creating template:", error);
        // Handle error, e.g., show an error message
      },
    });

    return mutation;
  };

  console.table("TEMPLATE_REPORT", `Report Name: ${reportName}`, `Company ID: ${companyId}`, `Tables: ${JSON.stringify(tables)}`);

  const createTemplateMutation = useCreateTemplate();
  const handleCreateTemplate = async () => {
    setLoading(true);
    try {
      // First, create the template
      const templateResponse = await createTemplateMutation.mutateAsync({
        reportName,
        companyId,
        tables,
      });

      // If template creation was successful and there's Excel data, upload it
      if (templateResponse?.data?.createTemplate?.success && Object.keys(excelDataByTable).length > 0) {
        const createdReportId = templateResponse?.data?.createTemplate?.data?.id;
        
        if (createdReportId) {
          const uploadPromises = [];
          
          // Upload Excel data for each table (data may include masterEntries)
          for (const [tableId, data] of Object.entries(excelDataByTable)) {
            uploadPromises.push(
              uploadExcelDataAPI(createdReportId, tableId, data)
            );
          }

          try {
            await Promise.all(uploadPromises);
            toast.success("Template and Excel data saved successfully");
          } catch (excelError) {
            console.error("Error uploading Excel data:", excelError);
            toast.warning("Template saved but some Excel data failed to upload");
          }
        }
      }

      // Reset form fields after successful creation
      setReportName("");
      setCompanyId("");
      setCompanyLocation();
      setCompanyName("");
      setTables([]);
      setEmail({ to: [], cc: [], bcc: [] });
      setExportConfig({
        generateType: "",
        blackAndWhite: false,
        orientation: "portrait",
      });
      setExcelDataByTable({});
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // Handle error if needed, although onError in useMutation already handles it
      console.error("Error in component:", error);
    }
  };

  const handleAddTable = (type) => {
    setTables((prevTables) => [
      ...prevTables,
      {
        id: Date.now(),
        type: type,
        tableName: "",
        columns: [],
      },
    ]);
    setChooseTable(false);
  };

  // console.log("121", tables);
  const handleDeleteTable = (tableIndex) => {
    const updatedTables = [...tables];
    updatedTables.splice(tableIndex, 1);
    setTables(updatedTables);
  };

  const handleTableNameChange = (tableIndex, value) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].tableName = value;
    setTables(updatedTables);
  };

  const handleAddColumn = (tableIndex) => {
    const updatedTables = [...tables];
    const tableType = updatedTables[tableIndex].type;
    
    const newColumn = {
      sequence: "",
      title: "Title",
      height: "15",
      // Default width: 10% for Tabular tables, 50% for Document tables
      width: tableType === "Tabular" ? "10" : "50",
      format: "textarea",
      border: "No",
      mandatory: "false",
      type: "",
      // dataSource: {
      //   excelColumn: "title",// <--- NEW: Excel column this field is linked to
      //   primary: false // <--- Optional: Mark as lookup key
      // }
    };

    if (tableType === "Tabular") {
      newColumn.fixed = [];
      newColumn.type = "";
    }

    updatedTables[tableIndex].columns.push(newColumn);
    setTables(updatedTables);
  };

  const handleAddfixedColumn = (tableIndex, columnIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].columns[columnIndex].fixed.push("");
    setTables(updatedTables);
  };

  const handleExcelUpload = async (tableIndex) => {
    // Validate tableIndex and tables array
    if (tableIndex === undefined || tableIndex === null || !Array.isArray(tables) || tableIndex < 0 || tableIndex >= tables.length) {
      toast.error("Invalid table selection");
      return;
    }

    const table = tables[tableIndex];
    if (!table || !table.id) {
      toast.error("Table not found");
      return;
    }

    const input = window.document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx,.xls";
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) {
        // Clean up input element
        input.remove();
        return;
      }

      try {
        const reader = new FileReader();
        reader.onload = async (event) => {
          try {
            // Re-validate table exists (in case state changed during async operation)
            const currentTable = tables[tableIndex];
            if (!currentTable || !currentTable.id) {
              toast.error("Table no longer available");
              input.remove();
              return;
            }

            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            if (jsonData.length === 0) {
              toast.error("Excel file is empty");
              input.remove();
              return;
            }

            // Row 1 (index 0): Master indicators (or legacy: headers if only one row); Row 2 (index 1): column headers
            const firstRow = jsonData[0] || [];
            const headerRow = jsonData.length >= 2 ? (jsonData[1] || []) : firstRow;
            const headers = headerRow.map(h => h != null && h !== "" ? String(h).trim() : "").filter(Boolean);
            
            if (headers.length === 0) {
              toast.error("No headers found in Excel file (use row 2 for headers)");
              input.remove();
              return;
            }

            // Build masterEntries: column names from row 2 where row 1 cell is "Master" (only when we have 2+ rows)
            const masterEntries = [];
            if (jsonData.length >= 2) {
              for (let col = 0; col < headers.length; col++) {
                const cell = firstRow[col];
                const isMaster = cell != null && String(cell).trim().toLowerCase() === "master";
                if (isMaster && headers[col]) masterEntries.push(headers[col]);
              }
            }

            const tableColumns = currentTable.columns || [];
            const dataStartIndex = jsonData.length >= 2 ? 2 : 1;
            // Map ALL Excel columns so every header (Driver Name, Container Name, Name, Age, etc.) is saved
            const mappedData = {};
            headers.forEach((headerName, headerIndex) => {
              const columnValues = [];
              for (let i = dataStartIndex; i < jsonData.length; i++) {
                const value = jsonData[i][headerIndex];
                if (value !== null && value !== undefined && value !== "") {
                  columnValues.push(String(value));
                }
              }
              if (columnValues.length > 0) mappedData[headerName] = columnValues;
            });
            // Require at least one Excel column to match a table column
            const tableTitles = new Set((tableColumns || []).map((c) => (c?.title || "").toLowerCase().trim()).filter(Boolean));
            const matchedColumns = headers.filter((h) => h && tableTitles.has(h.toLowerCase().trim())).length;
            if (matchedColumns === 0) {
              toast.error("No matching columns found between Excel headers and table fields");
              input.remove();
              return;
            }

            // Store full Excel data + masterEntries (saved when "Save Report" is clicked)
            const payload = { ...mappedData, masterEntries };
            setExcelDataByTable(prev => ({
              ...prev,
              [currentTable.id]: payload
            }));

            // Clean up input element first
            input.remove();

            toast.success(`Excel data loaded for ${matchedColumns} column(s). Click "Save Report" to save.`, { autoClose: 4000 });
          } catch (error) {
            console.error("Error processing Excel file:", error);
            toast.error("Failed to process Excel file");
            input.remove();
          }
        };
        
        reader.onerror = () => {
          toast.error("Failed to read file");
          input.remove();
        };
        
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error("Error reading file:", error);
        toast.error("Failed to read file");
        input.remove();
      }
    };
    
    input.click();
  };

  const [addTourPopUp, setAddTourPopUp] = useState(false);
  const handleChange = (tableIndex, columnIndex, fieldName, value) => {
    if (value === undefined) return;

    
    const updatedTables = [...tables];
    
    // If format is changing, check the previous format before updating
    const previousFormat = fieldName === "format" ? updatedTables[tableIndex].columns[columnIndex].format : null;
    
    // If sequence is being changed for a ref column, keep it at 1
    if (fieldName === "sequence" && updatedTables[tableIndex].columns[columnIndex].format === "ref") {
      value = "1";
    }
    
    // Handle width/height: strip % sign for storage
    if (fieldName === "width" || fieldName === "height") {
      value = String(value).replace('%', '');
    }
    
    updatedTables[tableIndex].columns[columnIndex][fieldName] = value;
    
    // Ensure ref columns always have sequence 1 in the data
    if (updatedTables[tableIndex].columns[columnIndex].format === "ref") {
      updatedTables[tableIndex].columns[columnIndex].sequence = "1";
    }

    // If the title is changed, update excelColumn with underscored version
    // if (fieldName === "title" && typeof value === "string") {
    //   const underscored = value.trim().toLowerCase().replace(/\s+/g, "_");
    //   updatedTables[tableIndex].columns[columnIndex].dataSource = {
    //     ...updatedTables[tableIndex].columns[columnIndex].dataSource,
    //     excelColumn: underscored,
    //   };
    // }

    // If format is changing away from "fixed value", reset fixed and close modal (fixed value data is not valid for qrcode/tour).
    if (fieldName === "format") {
      if (previousFormat === "fixed value" && value !== "fixed value") {
        setAddfixedValues(false);
        updatedTables[tableIndex].columns[columnIndex].fixed = [];
      }
      if (value === "fixed value") {
        // When entering "fixed value", ensure we start with empty fixed values.
        // This prevents Tour/Qrcode prefilled data from leaking into Fixed Value fields.
        if (previousFormat !== "fixed value") {
          updatedTables[tableIndex].columns[columnIndex].fixed = [];
        }
        setTableIndex(tableIndex);
        setColumnIndex(columnIndex);
        setShowModal(true);
        setAddfixedValues(true);
      }
      // If format is changed to "ref", set sequence to 1 and manage other sequences
      if (value === "ref") {
        // Ensure the format is set to "ref" first
        updatedTables[tableIndex].columns[columnIndex].format = "ref";
        // Then manage sequences (this will set ref to sequence 1)
        updatedTables[tableIndex].columns = manageSequencesForRef(
          updatedTables[tableIndex].columns,
          columnIndex
        );
      }
    }

    setTables(updatedTables);
    if (fieldName === "format" && value === "tour") {
      setTableIndex(tableIndex); // Store tableIndex for use in handleConfirmTour
      setColumnIndex(columnIndex); // Store columnIndex for use in handleConfirmTour
      setAddTourPopUp(true);
      FetchAllTours();
    }
    if (fieldName === "format" && value === "checkpoint") {
      const tourColumn = updatedTables[tableIndex].columns.find(
        (col) => col.type === "tour"
      );

      if (tourColumn && tourColumn.fixed) {
        const checkpointNames = tourColumn.fixed
          .map((checkpointString) => {
            try {
              const checkpoint = JSON.parse(checkpointString);
              return checkpoint.checkpointName;
            } catch (error) {
              console.error("Error parsing checkpoint JSON:", error);
              return null;
            }
          })
          .filter(Boolean);

        updatedTables[tableIndex].columns[columnIndex].fixed = checkpointNames;
      } else {
        toast.warn("Please add a tour to the table first.");
        updatedTables[tableIndex].columns[columnIndex].format = ""; // Revert format change
      }
    }
    if (fieldName === "format" && value === "qrcode") {
      updatedTables[tableIndex].columns[columnIndex].type = "tour";
      if (savedTourValues && savedTourValues.length > 0) {
        updatedTables[tableIndex].columns[columnIndex].fixed = savedTourValues;
      }
    }
  };
  // console.log("addTourPopUp", addTourPopUp);

  const handleChangefix = (tableIndex, columnIndex, value, fixedIndex) => {
    if (value === undefined) return;

    const updatedTables = [...tables];
    updatedTables[tableIndex].columns[columnIndex].fixed[fixedIndex] = value;
    setTables(updatedTables);
  };

  const handleDeleteRow = (tableIndex, columnIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].columns.splice(columnIndex, 1);
    setTables(updatedTables);
  };

  const handleDeleteFixedRow = (tableIndex, columnIndex, fixedIndex) => {
    const updatedTables = [...tables];
    updatedTables[tableIndex].columns[columnIndex].fixed.splice(fixedIndex, 1);
    setTables(updatedTables);
  };

  const handleUpdateReportTemplate = (e) => {
    e.preventDefault();
    handleCreateTemplate();

    // const IsReportName = reportTemplates.some(
    //   (report) => report.name === reportName
    // );
    // const IsCompanyName = reportTemplates.some(
    //   (report) => report.companyName === companyName
    // );
    // if (
    //   reportName !== "" &&
    //   IsReportName &&
    //   companyName !== "" &&
    //   IsCompanyName
    // ) {
    //   alert("Report Name and Company Name already exist");
    // } else {
    //   if (reportName !== "" && companyName !== "") {
    //     const reportTempRef = push(ref(database, "reportTemplates"));
    //     const reportTempId = reportTempRef.key;

    //     const reportTemplateRef = ref(
    //       database,
    //       `reportTemplates/${reportTempId}`
    //     );
    //     const updatedReportTemplate = {
    //       status: "Active",
    //       name: reportName,
    //       tables: tables,
    //       companyName: companyName,
    //       companyLocation: companyLocation,
    //       companyId,
    //       companyLocationId,
    //     };

    //     console.log("updatedReportTemplate", updatedReportTemplate);
    //   } else {
    //     alert("Please Fill Report Name && Select Company Name");
    //   }
    // }
  };

  // ----------------------------------------------------------------------------------

  // Document Table
  const CreateDocumentTable = () => {
    setOpenDocument(true);
    setChooseTable(false);
    handleAddTable("Document");
    // setDocumentTable((prev) => ({
    //   ...prev,
    //   tableName: docTableName,
    //   type: "document",
    //   documentTableData,
    // }));
  };
  // Tabular Table
  const CreateTabularTable = () => {
    handleAddTable("Tabular");
    setOpenTabular(true);
    setChooseTable(false);
    setTabularTable((prev) => ({
      ...prev,
      tableName: TabuTableName,
      type: "tabular",
      documentTableData,
    }));
  };

  // console.log("documentTable", documentTable);

  useEffect(() => {
    setDocumentTable((prev) => ({ ...prev }));
  }, [documentTableData]);

  const [reportData, setReportData] = useState({
    reportName: "",
    companyName: "",
    companyLocation: "",
  });

  const ReportFormDataHandler = (e) => {
    const { name, value } = e.target;
    setReportData((prevReport) => ({
      ...prevReport,
      [name]: value,
    }));
  };

  // all table and all the data add on this
  const ReportDataHandler = () => { };

  const generateNewID = uuidv4();
  const randomID = generateNewID.slice(0, 8);

  useEffect(() => {
    // const usersRef = ref(database, "users");
    // get(usersRef)
    //   .then((snapshot) => {
    //     if (snapshot.exists()) {
    //       const data = snapshot.val();
    //       console.log(">>>", data);
    //       const templatesArray = Object.keys(data)
    //         .filter((key) => data[key].type === "Client")
    //         .map((key) => ({
    //           id: key,
    //           ...data[key],
    //         }));
    //       setUsers(templatesArray);
    //     } else {
    //       setErrorMessage("No User Profiles found");
    //     }
    //   })
    //   .catch((error) => {
    //     setErrorMessage(`Error fetching User Profiles: ${error.message}`);
    //   });

    // ------------------- REPORT TEMPLATE FETCH FOR CHECK IT EXIST OR NOT WHEN USER CLICK ON SAVE REPORT --------------------------

    const reportTemplatesRef = ref(database, "reportTemplates");

    // Fetch data from Firebase Realtime Database
    get(reportTemplatesRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const templatesArray = Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
          }));
          setReportTemplates(templatesArray);
        } else {
          setErrorMessage("No report templates found");
        }
      })
      .catch((error) => {
        setErrorMessage(`Error fetching report templates: ${error.message}`);
      });
  }, []);

  // fixed Value
  const fixedPayload = {
    id: randomID,
    value: "",
  };

  const [fixedValues, setFixedValues] = useState("");
  // const [addfixedValues, setAddfixedValues] = useState(false);

  // --------------------------------------------

  // const DeleteHandler = (id) => {
  //   console.log("id", id);
  //   const updated = documentTableData.filter((item) => item.id !== id);
  //   setDocumentTableData(updated);
  // };

  const [openTabularPreview, setopenTabularPreview] = useState(false);
  const [openDocumentPreview, setopenDocumentPreview] = useState(false);

  // const documentInputHandler = (e, id) => {
  //   const { name, value } = e.target;
  //   const updatedDocumentTableData = documentTableData.map((item) =>
  //     item?.id === id ? { ...item, [name]: value } : item
  //   );
  //   setDocumentTableData(updatedDocumentTableData);
  // };
  // const TabularInputHandler = (e, id) => {
  //   const { name, value } = e.target;
  //   const updatedDocumentTableData = TabularTableData.map((item) =>
  //     item?.id === id ? { ...item, [name]: value } : item
  //   );
  //   if (name === "format" && value === "fixed value") {
  //     setAddfixedValues(true);`
  //   }

  //   setTabularTableData(updatedDocumentTableData);
  // };

  // console log

  // useEffect(() => {
  //   // console.log("documentTableData", documentTableData);
  //   console.log("fixedValues", fixedValues);
  // }, [documentTableData, TabularTableData, fixedValues]);

  // ---------------------------------
  const [successMessage, setSuccessMessage] = useState("");
  const naviagte = useNavigate();

  // console.log("tables", tables);

  const [previewTableIds, setPreviewTableIds] = useState([]);
  const [excelDataByTable, setExcelDataByTable] = useState({});

  const PreviewHandler = (tableId) => {
    const have = previewTableIds.includes(tableId);
    if (have) {
      const filter = previewTableIds.filter((table) => table !== tableId);
      setPreviewTableIds(filter);
    } else {
      setPreviewTableIds([...previewTableIds, tableId]);
    }
  };

  useEffect(() => {
    if (reportName || companyName || (tables && tables.length > 0)) {
      setIsChangesInCreateReport(true);
    } else {
      setIsChangesInCreateReport(false);
    }
  }, [reportName, companyName, tables]);

  // console.log("companyListcompanyList", companyId);

  const [allTour, setAllTours] = useState("");
  const [allTourLoading, setTourLoading] = useState(false);
  const [selectedTour, setSelectedTour] = useState("");
  const FetchAllTours = async () => {
    setTourLoading(true);
    // setError(null);
    try {
      const response = await GetAllTourAPI();
      const tourData = response || []; // Adjust based on actual API response structure
      setAllTours(tourData);
    } catch (error) {
      // setError("Failed to fetch tours. Please try again.");
      console.error("Error fetching tours:", error);
    } finally {
      setTourLoading(false);
    }
  };

  const [savedTourValues, setTourValues] = useState([]);

  const handleConfirmTour = async () => {
    if (!selectedTour) {
      toast.error("Please select a tour");
      return;
    }

    try {
      const tour = await GetTourByIdAPI(selectedTour);
      const checkpointNames = tour?.checkpoints?.map((checkpoint) => checkpoint.checkpointName) || [];
      const parseValue = tour?.checkpoints?.map((checkpoint) => JSON.stringify({ ...checkpoint, distance: tour?.distance })) || [];

      const updatedTables = [...tables];
      const columnFormat = updatedTables[tableIndex]?.columns[columnIndex]?.format;

      if (columnFormat === "qrcode") {
        updatedTables[tableIndex].columns[columnIndex].fixed = parseValue;
        updatedTables[tableIndex].columns[columnIndex].type = "tour";
      } else {
        updatedTables[tableIndex].columns[columnIndex].fixed = checkpointNames;
        updatedTables[tableIndex].columns[columnIndex].type = "fixedValue";
      }
      updatedTables[tableIndex].columns[columnIndex].tourId = tour?.id;

      setTables(updatedTables);
      setTourValues(parseValue);
      setAddTourPopUp(false);
      setSelectedTour("");
    } catch (error) {
      toast.error("Failed to fetch checkpoints");
      console.error("Error in handleConfirmTour:", error);
    }
  };


  // console.log("savedTourValues", savedTourValues);
  return (
    <>
      <Modal
        isOpen={addTourPopUp}
        onClose={() => setAddTourPopUp(false)}
        title="Choose tour"
        size="md"
        showCloseButton={true}
      >
        <div className="space-y-4">
          <select
            className="w-full shadow p-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setSelectedTour(e.target.value)}
          >
            <option>Choose the tour</option>
            {allTour &&
              allTour.map((item, index) => {
                return (
                  item?.companyId === companyId && (
                    <option key={item?.id} value={item?.id}>
                      {item?.tourName}
                    </option>
                  )
                );
              })}
          </select>
          {!companyId && (
            <div className="text-red-500 text-xs">Choose company first</div>
          )}
          {companyId && (
            <div className="flex justify-center">
              <button
                className="text-white bg-blue-500 text-sm p-2 px-4 rounded-md hover:bg-blue-600 transition-colors duration-200"
                onClick={handleConfirmTour}
              >
                Confirm
              </button>
            </div>
          )}
        </div>
      </Modal>

      {/* {
        ShowPopUp && popupMessage && (
          <PopupModel
            message={popupMessage}
            onClose={() => setShowPopUP(false)}
          />
        )
        // <PopUp title={`Report Assignment Already Exist`} />
      } */}
      <div
        className={`flex flex-col gap-2 h-full relative text-sm createReportScroll ${PixelStyle}`}
      >
        <HeaderContainer pageTitle="create Report" isRedirecting={false}>
          <span className="text-black">create report</span>
        </HeaderContainer>

        <div className="w-full flex gap-3 ">
          <div className="w-full flex items-center justify-between gap-10 bg-white shadow p-3 rounded-lg">
            <div className="flex items-center gap-3 w-full">
              <input
                placeholder="Report Name"
                className="border border-zinc-200 p-2 rounded-md w-full"
                // onChange={ReportFormDataHandler}
                value={reportName}
                onChange={(e) => setReportName(e.target.value)}
                name="reportName"
              />

              <SearchableDropdown
                users={companyList}
                selectedCompany={companyName}
                setCompanyId={setCompanyId}
                onSelect={setCompanyName}
                setCompanyLocationId={setCompanyLocationId}
                setCompanyLocation={setCompanyLocation}
              />

              {/* <input
                className='border border-zinc-200 p-2 rounded-md w-full'
                type='text'
                id='companyLocationID'
                value={companyLocation}
                onChange={(e) => setCompanyLocation(e.target.value)}
                placeholder='Company Location...'
              /> */}

              <div className="border border-zinc-200 p-2 rounded-md w-full text-nowrap overflow-x-auto min-w-40  scrollHeight">
                {companyLocation ? (
                  companyLocation
                ) : (
                  <span className="text-zinc-400">Location </span>
                )}
              </div>
            </div>
            <div>
              <button
                onClick={() => setChooseTable(!chooseTable)}
                className={`border ${
                  chooseTable
                    ? "border-red-500 text-red-500"
                    : "border-blue-500 text-blue-600"
                } p-2 px-5 rounded-md flex items-center gap-1 font-semibold text-nowrap`}
              >
                <MdOutlineAdd
                  className={`text-xl transition duration-300 ${
                    chooseTable ? "rotate-45" : ""
                  }`}
                />
                {chooseTable ? "Close" : "Add data"}
              </button>
            </div>
          </div>
          <div className="bg-white shadow p-3 rounded-lg text-nowrap flex items-center gap-2">
            <button
              className="p-2 px-5 rounded-md bg-blue-500 text-white"
              onClick={handleUpdateReportTemplate}
            >
              {loading ? (
                <Loader2 className="animate-spin" size={20} />
              ) : (
                "Save Report"
              )}
            </button>
          </div>
        </div>

        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 ">
          <div className="transform transition-all duration-300 ">
            <EmailSection email={email} onChange={setEmail} />
          </div>
          <div className="transform transition-all duration-300 ">
            <ExportConfig exportConfig={exportConfig} onChange={setExportConfig} />
          </div>
        </div>

        <div className="flex flex-col gap-5 items-center justify-start my-5 pb-20 relative  ">
          {chooseTable && (
            <div className="fixed inset-0 z-50 flex backdrop-blur-sm  items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-xl shadow-2xl drop-shadow-2xl p-6 w-96">
                <div className="flex justify-between items-center mb-2">
                  <h1 className="text-base  w-full text-center font-bold text-black">
                    Select Data Type
                  </h1>
                  <button
                    onClick={() => setChooseTable(false)}
                    className="text-gray-500 hover:text-gray-700 text-2xl"
                  >
                    ×
                  </button>
                </div>
                <div className="border-t border-gray-200 mb-6"></div>
                <div className="flex gap-4">
                  <button
                    onClick={() => {
                      setSelectedDataType("Fields");
                      CreateDocumentTable();
                    }}
                    className={`flex-1 py-3 px-6 rounded-lg bg-blue-600 text-white font-semibold transition-colors border border-gray-300`}
                  >
                    Fields
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDataType("Table");
                      CreateTabularTable();
                    }}
                    className={`flex-1 py-3 bg-blue-600 text-white px-6 rounded-lg font-semibold transition-colors ${
                      selectedDataType === "Table"
                        ? "bg-blue-600 text-white"
                        : ""
                    }`}
                  >
                    Table
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="w-full mb-10 space-y-2">
            {tables.map((table, tableIndex) => (
              <React.Fragment key={table.id} >
                {table.type === "Document" && (
                  <div className={`flex flex-col gap-3 w-full my-5 `}>
                    <div className="bg-white  shadow rounded-md overflow-hidden ">
                      <div className="bg-[#00325d] text-white w-full text-xs text-green-700 py-0.5 font-semibold px-4 ">
                        Fields
                      </div>
                      <div className="p-4 w-full flex flex-col gap-5">
                        <div className="flex justify-between">
                          <div className="flex flex-col items-start">
                            <input
                              placeholder="Field Name"
                              value={table?.name}
                              // onChange={(e) => setDocTableName(e.target.value)}
                              onChange={(e) =>
                                handleTableNameChange(
                                  tableIndex,
                                  e.target.value
                                )
                              }
                              className="bg-transparent outline-none text-2xl font-bold mb-1 text-zinc-600"
                            />
                            {docTableName === "table 1" && (
                              <span className="border-[#00325d] border rounded-full px-5 text-xs text-[#00325d]">
                                Editable
                              </span>
                            )}
                          </div>
                          <div className="flex items-center gap-3">
                            <button
                              className={`flex items-center gap-2 border p-1.5 px-4 rounded-md ${
                                previewTableIds.includes(table.id)
                                  ? " border-[#00325d]"
                                  : ""
                              }`}
                              onClick={() => PreviewHandler(table.id)}
                            >
                              {previewTableIds.includes(table.id) ? (
                                <LuEye />
                              ) : (
                                <LuEyeOff />
                              )}
                              <span className="text-xs"> Preview</span>
                            </button>

                            <button
                              onClick={() => handleDeleteTable(tableIndex)}
                              className="text-zinc-600 text-lg hover:text-red-400 border border-zinc-200 hover:border-red-200 p-1.5 rounded-lg"
                            >
                              <RiDeleteBin6Line />
                            </button>
                          </div>
                        </div>
                        <div class="relative overflow-x-auto pb-8 ">
                          <table class="w-full text-sm text-left rtl:text-right ">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                              <tr>
                                <th scope="col" class="px-6 py-3">
                                  Sequence
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Title
                                </th>
                                {/* <th scope='col' class='px-6 py-3'>
                          Height (px)
                        </th> */}
                                <th scope="col" class="px-6 py-3">
                                  Width (%)
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Specific Format
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Border
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  Mandatory
                                </th>
                                <th scope="col" class="px-6 py-3">
                                  <button
                                    onClick={() => handleAddColumn(tableIndex)}
                                    className="p-1 px-2 border-2  border-green-400 text-green-500 rounded-lg flex items-center gap-1"
                                  >
                                    <MdOutlineAdd className="text-lg" />
                                    <span className="">ADD</span>
                                  </button>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {table.columns.map((column, columnIndex) => (
                                <tr class="bg-white border-b  ">
                                  <th
                                    scope="row"
                                    class="px-5 py-4 font-medium text-black whitespace-nowrap "
                                  >
                                    <Input
                                      placeholder="Sequence"
                                      className="w-20"
                                      value={
                                        column?.format === "ref" 
                                          ? "1" 
                                          : (column?.sequence || "")
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "sequence",
                                          e.target.value
                                        )
                                      }
                                      disabled={column?.format === "ref"}
                                      name="sequence"
                                    />
                                  </th>
                                  <td class="px-5 py-4">
                                    <Input
                                      placeholder="Title"
                                      value={column.title}
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "title",
                                          e.target.value
                                        )
                                      }
                                      name="title"
                                    />
                                  </td>
                                  {/* <td class='px-5 py-4'>
                            <Input
                              placeholder='Height'
                              onChange={(e) =>
                                documentInputHandler(e, column?.id)
                              }
                              name='height'
                            />
                          </td> */}
                                  <td class="px-5 py-4">
                                    {/* <Input
                                      className='w-20'
                                      placeholder='width'
                                      value={column.width}
                                      onChange={(e) =>
                                        e.target.value <= 100 &&
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "width",
                                          e.target.value
                                        )
                                      }
                                      name='width'
                                    /> */}

                                    <select
                                      className="px-2 border p-2 rounded-md"
                                      value={column.width ? `${column.width}%` : "50%"}
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "width",
                                          e.target.value
                                        )
                                      }
                                      name="width"
                                    >
                                      <option>50%</option>
                                      <option>100%</option>
                                    </select>
                                  </td>

                                  <td class="px-5 py-4">
                                    {/* <Input placeholder='Format ' /> */}
                                    <select
                                      className="px-2 border p-2 rounded-md"
                                      value={column.format}
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "format",
                                          e.target.value
                                        )
                                      }
                                      name="format"
                                    >
                                      {/* <option value="input">Text</option> */}
                                      <option value="number">Number</option>
                                      <option value="date">Date</option>
                                      {/* <option value="time">Time</option> */}
                                      <option value="textarea">
                                        Text
                                      </option>
                                      <option value="Yes/No">Yes/No</option>
                                      <option value="photo Upload">
                                        Photo Upload
                                      </option>
                                      <option value="photo Capture">
                                        Photo Capture
                                      </option>
                                      <option value="f&c">F&C</option>
                                      <option value={"time am/pm"}>
                                        Time - AM/PM
                                      </option>
                                      <option value={"time military"}>
                                        Time - Military
                                      </option>
                                      <option value={"checkbox"}>
                                        Checkbox
                                      </option>
                                      <option value={"e-sign"}>E-sign</option>
                                    </select>
                                  </td>
                                  <td class="px-6 py-4">
                                    <select
                                      className="px-2 border p-2 rounded-md "
                                      value={column.border}
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "border",
                                          e.target.value
                                        )
                                      }
                                      name="border"
                                    >
                                      <option>no</option>
                                      <option>yes</option>
                                    </select>
                                  </td>
                                  <td class="px-6 py-4">
                                    <select
                                      className="px-2 border p-2 rounded-md "
                                      value={column.mandatory}
                                      onChange={(e) =>
                                        handleChange(
                                          tableIndex,
                                          columnIndex,
                                          "mandatory",
                                          e.target.value
                                        )
                                      }
                                      name="mandatory"
                                    >
                                      <option value={"false"}>no</option>
                                      <option value={"true"}>yes</option>
                                    </select>
                                  </td>
                                  <td className="">
                                    <div className="flex justify-center items-center">
                                      {/* {item?.id} */}
                                      <RiDeleteBin6Line
                                        className="text-xl text-red-500 cursor-pointer"
                                        onClick={() =>
                                          handleDeleteRow(
                                            tableIndex,
                                            columnIndex
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {previewTableIds.includes(table.id) && (
                      <div className=" bg-white shadow rounded-md overflow-hidden">
                        <div className="bg-[#00325d] text-white w-full text-xs text-green-700 py-0.5 font-semibold px-4 ">
                          Preview
                        </div>
                        <div className="">
                          <div className="">
                            {table?.name && (
                              <p className="font-semibold mb-3 px-2 border-b pb-1">
                                {table?.name}
                              </p>
                            )}
                            <div className=" grid grid-cols-1 md:grid-cols-2">
                              {Array.from({
                                length: Math.max(
                                  ...table.columns.map((item) => item.sequence)
                                ),
                              }).map((_, i) => {
                                const item = table.columns.find(
                                  (column) => Number(column.sequence) === i + 1
                                );

                                return (
                                  <div key={i} className="p-2">
                                    <div key={i + 1}>
                                      {item ? (
                                        <div className="p-2 grid grid-cols-2 items-start gap-1">
                                          <span className="font-semibold  bg-[#00325d] text-white border border-[#00325d] px-2 p-1">
                                            {item.title
                                              ? item.title
                                              : "Empty Title"}
                                          </span>
                                          <span
                                            className={`p-1 ${
                                              item.width === "100" ||
                                              item.width === "100%"
                                                ? "col-span-2 row-start-2"
                                                : "col-span-1"
                                            }`}
                                            style={
                                              item.border === "yes"
                                                ? { borderWidth: "1px" }
                                                : {}
                                            }
                                          >
                                            {item.format}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className=" bg-zinc-100 rounded-md py-2 "></div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {table.type === "Tabular" && (
                  <>
                    <TabularTableComponent
                      table={table}
                      tableIndex={tableIndex}
                      handleTableNameChange={handleTableNameChange}
                      handleChange={handleChange}
                      handleAddColumn={handleAddColumn}
                      handleDeleteTable={handleDeleteTable}
                      handleDeleteRow={handleDeleteRow}
                      PreviewHandler={PreviewHandler}
                      previewTableIds={previewTableIds}
                      UploadHandler={handleExcelUpload}
                      hasExcelData={!!excelDataByTable[table.id]}
                    />
                    {previewTableIds.includes(table.id) && (
                      <TabularTablePreview table={table} />
                    )}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>

          {addfixedValues && (
            <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
              <div className="bg-white rounded-lg p-4 shadow-lg w-1/2 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center">
                  <div className=" text-zinc-600 font-semibold">
                    Fixed Value
                  </div>
                  <button
                    onClick={() =>
                      handleAddfixedColumn(tableIndex, columnIndex)
                    }
                    className="p-1 px-2 border-2 text-sm  border-green-400 text-green-500 rounded-lg flex items-center gap-1"
                  >
                    <MdOutlineAdd className="text-lg" />
                    <span className="">ADD</span>
                  </button>
                </div>
                <div>
                  <table class="w-full text-sm   text-gray-500 my-4  ">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
                      <tr>
                        <th scope="col" class="px-6 py-3 w-full">
                          value
                        </th>
                        <th scope="col" class="px-6 py-3">
                          remove
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tables[tableIndex]?.columns[columnIndex]?.fixed?.map(
                        (fix, fixedIndex) => {
                          console.log("fix", fix);
                          return (
                            <tr key={fixedIndex} class="bg-white border-b  ">
                              <td class="px-5 py-4 font-medium text-black whitespace-nowrap ">
                                <Input
                                  placeholder="Titles"
                                  className="w-full"
                                  value={fix} //fix.item
                                  onChange={(e) =>
                                    handleChangefix(
                                      tableIndex,
                                      columnIndex,
                                      e.target.value,
                                      fixedIndex
                                    )
                                  }
                                  name="value"
                                />
                              </td>
                              <td className="">
                                <div className="flex justify-center items-center">
                                  {/* {item?.id} */}
                                  <RiDeleteBin6Line
                                    className="text-xl text-red-500 cursor-pointer"
                                    onClick={() =>
                                      handleDeleteFixedRow(
                                        tableIndex,
                                        columnIndex,
                                        fixedIndex
                                      )
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                  <button
                    onClick={() => setAddfixedValues(false)}
                    className="bg-blue-100 w-full p-2 rounded-md mt-2 border border-blue-300 text-blue-600 font-semibold"
                  >
                    Done
                  </button>
                  <button
                    onClick={() => setAddfixedValues(false)}
                    className="bg-red-100 w-full p-2 rounded-md mt-2 border border-red-300 text-red-600 font-semibold"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CreateReport;

const Input = ({ placeholder, className, ...props }) => {
  return (
    <input
      placeholder={placeholder}
      className={`border border-zinc-200 outline-blue-500 p-2 rounded-md ${className || ''}`}
      {...props}
    />
  );
};